import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import "./IndexProveedorComercializador.css";
import MenuProv from "../componentsProveedorComercializador/MenuLeftProveedorComercializador/menuLeftProv";
import MenuPhone from "../componentsProveedorComercializador/MenuLeftPhoneProvComercializador/menuLeftPhoneProv";
import ProfileprovUser from "../profileprovUserComercializador/profileprovUser";
import TermsConditionIndex from "../TermsConditionIndex/TermsConditionIndex";
import Provdocumentation from "../provdomuentationComercializador/provdocumentation";
import UpdateBill from "../updateBill/updateBill";
import ChangePassword from "../ChangePassword/ChangePassword";
import Welcome from "../welcome/welcome";
import AlertProv from "../AlertProv/AlertProv";
import AlertPercentage from "../AlertPercentage/AlertPercentage";

import jurada from "../../assets/pdf/declaracion_jurada_AMEBO.pdf";
import conducta from "../../assets/pdf/Codigo_conducta_AMEBO.pdf";

const IndexProveedorComercializador = () => {
  const [viewSeeProv, setViewPageProv] = useState(null);
  const [alertid, setAlertId] = useState(null);
  const location = useLocation();
  let data = location.state;
  const tipeviewSee = (datos) => {
    setViewPageProv(datos);
  };

  if (!data) {
    const storedData = sessionStorage.getItem("Data");
    if (storedData) {
      data = JSON.parse(storedData);
    }
  } else {
    // Almacena los datos en sessionStorage si están disponibles
    sessionStorage.setItem("Data", JSON.stringify(data));
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ALERTS_SUPPLIER);

        if (response.data.length > 0 && response.data.includes(data.id)) {
          setAlertId(data.id);
        }
      } catch (error) {
        console.error("Error al obtener los datos:", error);
      }
    };

    fetchData();
  }, [data.id]);

  useEffect(() => {
    Swal.fire({
      title: "Cobro de comisiones",
      text: "Estimado comercializador, le pedimos por favor que descargue los siguientes documentos para poder cobrar las comisiones. Una vez completados, deberá enviarlos a mutualamebo@mutualamebo.com",
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Descargar documentos",
      cancelButtonText: "Cerrar",
    }).then((result) => {
      if (result.isConfirmed) {
        const archivos = [
          {
            ruta: jurada,
            nombre: "Anexo I declaracion jurada - AMEBO.pdf",
          },
          {
            ruta: conducta,
            nombre: "Codigo de conducta - AMEBO.pdf",
          },
        ];

        archivos.forEach((archivo) => {
          const link = document.createElement("a");

          link.href = archivo.ruta;
          link.download = archivo.nombre;

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
      }
    });
  }, []);

  return (
    <div className="boxprovmenuallmenu">
      <MenuProv viewSee={tipeviewSee} />
      <MenuPhone viewSee={tipeviewSee} />

      {alertid !== null ? <AlertProv /> : null}
      <AlertPercentage />

      {viewSeeProv === "Perfil" ? <ProfileprovUser /> : null}
      {viewSeeProv === "Convenio" ? <TermsConditionIndex data={data} /> : null}
      {viewSeeProv === "Factura" ? <UpdateBill data={data} /> : null}
      {viewSeeProv === "Documentacion" ? (
        <Provdocumentation data={data} />
      ) : null}
      {viewSeeProv === "Contraseña" ? <ChangePassword data={data} /> : null}
      {viewSeeProv === null && <Welcome data={data} />}
    </div>
  );
};

export default IndexProveedorComercializador;
